import React from "react"
import {Link} from "react-router-dom"
import classNames from "classnames"
import {romanize} from "utils/utils"
import useRescuers from "hooks/useRescuers"
import "./Application.css"

export default function Application(props) {

    const {application, details} = props
    const {getUser} = useRescuers()
    const rescuer = getUser(application.rescuer.username)
    const scoreFormat = new Intl.NumberFormat('sr', { 
        maximumFractionDigits: 3, 
        minimumFractionDigits: 3 
    })
    const warning = rescuer && (!rescuer.ski || !rescuer.coef || !rescuer.membership_paid)
    
    return <li className={classNames({"canceled": application.canceled})} title={`${romanize(application.wish)} želja: ${application.score}`}>
        <Link className="rescuer" to={`/rescuer/${rescuer.username}`}>{rescuer.given_name} {rescuer.family_name}, {rescuer.nickname || ''} {rescuer.gss_id || ''} {warning && <i class="fa-solid fa-triangle-exclamation"/>}</Link>
        {details && <div className="details">
            {!rescuer.coef && <span className="warning">Licenca</span>}
            {!rescuer.membership_paid && <span className="warning">Članarina</span>}
            {rescuer.coef > 0 && <span>{romanize(application.wish)} želja: {scoreFormat.format(application.score)}</span>}
            {rescuer.ski && <span>Skijanje: {rescuer.ski}</span>}
            {!rescuer.ski && <span className="warning">Skijanje</span>}
        </div>}
    </li>
}